import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import LoaderThreeDot from './Loader/LoaderThreeDot';
import { SESSION_MANAGER_API_URL } from './ConstVariable';

const InitializeSession = ({setSessionValidated}) => {
  const { isLoading, isAuthenticated, error, getAccessTokenSilently, user } =useAuth0();
  const UserOiProfile = user?.oi_profile;
  useEffect(async () => {
        if (isAuthenticated) {
            const token = await getAccessTokenSilently();
            localStorage.MyToken = token;
            localStorage.USER = user.email
            var form_data = new FormData();
            form_data.append("auth0_token", token);
            form_data.append("session_limit", 20);
            // let headers = { "Content-Type": "multipart/form-data", "Authorization": `Bearer ${token}` }
            // console.log("headers:", headers)
            let options = {
                method: "POST",
                url: `${SESSION_MANAGER_API_URL}/session/v1/init`,
                headers: {
                    "content-type": `multipart/form-data`,
                },
                withCredentials: true,
                data: form_data
            }

            if (token) {
                options = {
                    ...options,
                    headers: {
                        ...options.headers,
                        Authorization: `Bearer ${token}`,
                    },
                    withCredentials: true
                };
            }
            console.log("options:", options)
            // options = addTokenIfExists(options);
            axios(options).then((response) => {
                setSessionValidated(true);
            })
        }

    }, [isAuthenticated])

  return (
     <div
         className="text-center"
                    style={{
                        marginTop: "45vh",
                    }}
                >
                    <LoaderThreeDot/>
                </div>
  )
}

export default InitializeSession
